import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import './style.scss';

import TooltipDropDown from '@common/components/tooltipDropDown';

import MpesaLogo from '@app/dev/images/mpesa.svg';
import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';

export const MpesaPayment = () => {
  const user = useSelector((state) => state.user);
  const { profile, loggedIn, loggedInByRFID, rfid, freeBonuses } = user;
  const [{ openPopup }] = useContext(PopupContext);

  const userLoggedin = loggedInByRFID || loggedIn;

  if (!userLoggedin) return null

  const options = [
    {
      buttonName: "Deposit",
      iconName: "icon-mpesa-deposit",
      enabled: true,
      callback: () => openPopup(POPUPS.MPESA_DEPOSIT)
    },
    {
      buttonName: "Withdraw",
      iconName: "icon-cashout",
      enabled: true,
      callback: () => openPopup(POPUPS.MPESA_WITHDRAW)
    },
  ]

  return (
    <TooltipDropDown
      options={options}
      header={<div className="mpesa-payment-header">
        <img src={MpesaLogo} alt="Mpesa" />
        <span>M-PESA</span>
        <i className="global-icon icon-thin-arrow-down" />
      </div>}
      se
    />
  );
};